module.exports = __webpack_public_path__ + "media/images/icons/icon-boost-2664b0fd886b3b0ae509ed241db0771d.svg";